import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";
import VueTheMask from "vue-the-mask";
import Datetime from "vue-datetime";
import 'vue-datetime/dist/vue-datetime.css'
import { Settings } from 'luxon';
import Toasted from "vue-toasted";
import "vue-swatches/dist/vue-swatches.css";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import './globalFilters';

// router setup
import router from "./router";

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  Vue,
  dsn: "https://97208e92805d43c1b37f0cb4b0458ea9@o527393.ingest.sentry.io/5722114",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(VueTheMask);
Vue.use(Datetime);
Vue.use(Toasted, { position: "bottom-right", duration: 2000 });
Settings.defaultLocale = "pt-BR";
Vue.component('v-select', vSelect);

// global library setup
Object.defineProperty(Vue.prototype, "$Chartist", {
	get () {
		return this.$root.Chartist;
	}
});

new Vue({
	el: "#app",
	render: h => h(App),
	router,
	data: {
		Chartist: Chartist
	},
});
